/*
 * @Description: 输入为空弹出框
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-11 14:37:10
 * @LastEditTime: 2019-05-06 16:22:00
 */


import React from 'react';
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './SearchError.css';
// @ts-ignore
import pic from './seaeor.jpg'
import history from '../../history';

const list=[
  '支付宝',
  '美的',
  '海尔'
]

class SearchError extends React.Component {
  constructor(props){
    super(props)
    this.seaHot = this.seaHot.bind(this)
  }
  
  static defaultProps = {
    close: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired
  }

  /**
   * 跳转到品牌详情
   * @param {Number} i 
   */
  seaHot (i) {
    localStorage.setItem('seaName',`${list[i]}`)
    history.push(`/dashboard?brandName=${list[i]}`)
    this.props.close()
  }

  renderModel () {
    return (
      <div className={s.root}>
        <div className={s.model}>
          <div className={s.close} onClick={this.props.close}> × </div>
          <div className={s.title}> 抱歉，您输入的品牌名称有误或该品牌尚未收录在DBRank品牌库中，我们将尽快收录 </div>
          <div className={s.pic}>
            <img src={pic} alt="异常"/>
          </div>
          <div className={s.hot}>
            最近热搜：
            { list.map((item,i) => <span key={i} onClick={()=>this.seaHot(i)}>{item}</span>) }
          </div>
        </div>
      </div>
    )
  }

  render() {
    return ( !!this.props.show ? this.renderModel() : null )
  }
}

export default withStyles(s)(SearchError);



// WEBPACK FOOTER //
// src/components/SearchError/SearchError.js